import type { SVGProps } from 'react';

export function TransactionRejectedIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <circle cx="24" cy="24" r="24" fill="url(#paint0_linear_rejected)"/>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.7892 19.2288C30.0702 18.9478 30.0702 18.4918 29.7892 18.2108C29.5082 17.9297 29.0522 17.9297 28.7712 18.2108L24 22.9819L19.2288 18.2108C18.9478 17.9297 18.4918 17.9297 18.2108 18.2108C17.9297 18.4918 17.9297 18.9478 18.2108 19.2288L22.9819 24L18.2108 28.7712C17.9297 29.0522 17.9297 29.5082 18.2108 29.7892C18.4918 30.0703 18.9478 30.0703 19.2288 29.7892L24 25.0181L28.7712 29.7892C29.0522 30.0703 29.5082 30.0703 29.7892 29.7892C30.0702 29.5082 30.0702 29.0522 29.7892 28.7712L25.0181 24L29.7892 19.2288Z"
        fill="#1C2633"
      />
      <defs>
        <linearGradient
          id="paint0_linear_rejected"
          x1="23.4985"
          y1="57.2906"
          x2="57.2234"
          y2="24.1204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F9F9"/>
          <stop offset="1" stopColor="#ff4141ff"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
